<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Persiapan Lelang</h5>
            </template>
            <div class="d-flex flex-wrap search-wrapper align-items-center justify-content-between" style="gap: 8px;">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex align-items-center search-input-wrapper">
                        <b-form-select class="ml-2 mr-2" v-model="input.filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button v-if="IS_HAVE_PERMISSION_RANGKUMAN_PACKING" class="mb-3" variant="pgiBtn" name="rekapPersiapanLelangBtn" @click="$bvModal.show('modal-confirm-rekap')">
                    <i class="fa fa-file-excel-o mr-2"></i>Rangkuman Packing Lelang
                </b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="dataPersiapanLelang" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data persiapan lelang untuk dicek.
                </template>
                <template v-slot:cell(tanggalOrder)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalOrder)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalOrder)}}</div>
                </template>
                <template v-slot:cell(tanggalKirim)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalKirim)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalKirim)}}</div>
                </template>
                <template v-slot:cell(jenisPinjaman)="row">
                    {{ (row.item.jenisPinjaman || []).join(', ') }}
                </template>
                <template v-slot:cell(packing)="row">
                    <div class="no-wrap">Sudah Packing: {{ row.item.jumlahSudahPacking }}</div>
                    <div class="no-wrap smallText text-muted">Belum Packing: {{ row.item.jumlahBelumPacking }}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'PACKING'">PACKING</b-badge>
                    <b-badge variant="success" v-else>TERKIRIM</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="batchLelangDetailBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PACKING</h6>
                <p class="smallText mb-0">Cabang mempersiapkan barang gadai sesuai dengan daftar yang tertera untuk dilelangkan. Pembayaran atau pelunasan terhadap barang akan dikenakan penalti.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">TERKIRIM</h6>
                <p class="smallText mb-0">Dinyatakan terkirim ke pelelangan atau drop-off.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="modal-confirm-rekap" title="Rangkuman Packing Lelang" :isSubmitting="isLoadRekap" desc="Rangkuman packing lelang semua cabang akan dibuat dalam bentuk file Excel. Lanjutkan?" @submit="onRekap" />
        <b-modal id="modal-download-rekap" centered title="Download Rangkuman Packing Lelang" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadRekap">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p>Sukses, silahkan download dengan klik tombol dibawah ini :</p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a :href="$baseFilePath + rekapFilePath">
                        <i class="fa fa-download mr-2"></i>
                        Download Rangkuman Packing Lelang
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'persiapan-lelang',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                // filterCabang: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "tanggalOrder", label: "Tanggal Order", sortable:true },
                { key: "tanggalKirim", label: "Tanggal Kirim", sortable:true },
                { key: "jumlahUnit", label: "Jumlah Unit", sortable:true },
                { key: "jumlahHilang", label: "Jumlah Hilang", sortable:true },
                { key: "jenisPinjaman", label: "Jenis Barang" },
                { key: "packing", label: "Packing" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [
                { id: 2, name: 'Packing' },
                { id: 3, name: 'Terkirim' },
            ],
            // filterCabang: null,
            dataPersiapanLelang: [],
            cabangId: '',
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
            isLoadRekap: false,
            rekapFilePath: ""
        }
    }, 
    computed: {
        IS_HAVE_PERMISSION_RANGKUMAN_PACKING() {
            return this.$helper.hasPermissionMenuChildren('LES')
        },
    },
    methods: {
        onRekap(){
            this.isLoadRekap = true
            this.$bvModal.hide('modal-confirm-rekap')
            this.$bvModal.show('modal-download-rekap')
            this.$axios.get('lelang-packing/export-excel-lelang-summary')
                .then(response => {
                    this.rekapFilePath = response.data
                })
                .catch(error => {
                    this.$bvModal.hide('modal-download-rekap')
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoadRekap = false
                })
        },

        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.cabangId = this.$helper.getCabangId()
            this.query = this.query+"&cabangId="+this.cabangId
            
            // this.input.filterCabang = this.$helper.getCabangId()

            // let getCabang = localStorage.getItem("cabang")
            // this.filterCabang = JSON.parse(getCabang)
            let getPersiapanLelang= this.$axios.get("lelang-persiapan/"+this.query).then(response => {
                this.dataPersiapanLelang = response.data.data
            
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            Promise.all([getPersiapanLelang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Cek Gadai -----------------

        getPersiapanLelang(){
            this.toggleBusy()
            this.dataPersiapanLelang = []
            this.cabangId = this.$helper.getCabangId()

            // if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc
            
            this.$axios.get("lelang-persiapan/"+this.query).then(response => {
                this.dataPersiapanLelang = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.query = this.query+"&cabangId="+this.cabangId
            this.getPersiapanLelang()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.query = this.query+"&cabangId="+this.cabangId
                this.getPersiapanLelang()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            // this.input.filterCabang = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.query = this.query+"&cabangId="+this.cabangId
            this.loading = true
            this.getPersiapanLelang()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.query = this.query+"&cabangId="+this.cabangId
            this.loading = true
            this.getPersiapanLelang()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

    },

    created(){
        this.init()
    }
}
</script>
